/* @flow */

import React, { Component } from "react";

type $Props = {
  descriptionLabel?: string,
  placeholder: string,
  labels: Array<string>,
  values: Array<string>,
  selectedValue: string,
  onChange: Function,
  modifierClass?: string
};

class WBDropdown extends Component<$Props> {
  render() {
    const {
      labels,
      values,
      selectedValue,
      modifierClass,
      descriptionLabel,
      placeholder,
      onChange
    } = this.props;

    const options = labels.map((label, idx) => ({ label, value: values[idx] }));

    return (
      <div className={modifierClass}>
        <wb-select-control
          class="dl-e-wb-dropdown"
          compact={!descriptionLabel || descriptionLabel.length < 1}
        >
          <wb-select class="dl-e-wb-dropdown__select">
            <label>{descriptionLabel}</label>
            <select
              value={selectedValue || ""}
              onChange={e => onChange(e.target.value)}
            >
              {placeholder && (
                <option hidden value="">
                  {placeholder}
                </option>
              )}
              {options.map(({ label, value }, idx) => (
                <option key={idx} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </wb-select>
        </wb-select-control>
      </div>
    );
  }
}

export default WBDropdown;
